import { createApp } from "vue";
import App from "./App.vue";
import { createPinia } from "pinia";
// Apollo
import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client/core";
import { DefaultApolloClient } from "@vue/apollo-composable";

import "./assets/Style.scss";
import router from "./router";
import Vue3PersianDatetimePicker from "vue3-persian-datetime-picker";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faChartLine,
  faFileInvoiceDollar,
  faBriefcase,
  faCog,
  faSignOutAlt,
  faArrowRight,
  faArrowLeft,
  faUser,
  faSignIn,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faCircleUser,
  faPenToSquare,
  faTrashCan,
  faBoxArchive,
  faCommentDots,
  faSearch,
  faCircleCheck,
  faBars,
  faEllipsis,
  faPaperclip,
  faTrash,
  faSave,
  faCamera,
  faVideo,
  faCameraRetro,
  faImage,
  faImages,
  faUpload,
  faDownload,
  faFilePdf,
  faFile,
  faPlay,
  faRefresh,
  faSpinner,
  faVolumeUp,
  faTimes,
  faRedo,
  faStop,
  faPause,
  faBell
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faChartLine,
  faFileInvoiceDollar,
  faBriefcase,
  faCog,
  faSignOutAlt,
  faArrowRight,
  faArrowLeft,
  faUser,
  faSignIn,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faCircleUser,
  faPenToSquare,
  faTrashCan,
  faBoxArchive,
  faCommentDots,
  faSearch,
  faCircleCheck,
  faBars,
  faEllipsis,
  faPaperclip,
  faTrash,
  faSave,
  faCamera,
  faVideo,
  faCameraRetro,
  faImage,
  faImages,
  faUpload,
  faDownload,
  faFilePdf,
  faFile,
  faPlay, 
  faPause, 
  faStop, 
  faRedo, 
  faTimes, 
  faVolumeUp, 
  faSpinner,
  faBell
);
// Import vue-toastification
import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// تنظیمات toast
const toastOptions = {
  timeout: 3000,
  position: POSITION.TOP_RIGHT,
  rtl: true, // برای راست به چپ بودن
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
}

// اگر env به هر دلیلی لود نشد، روی /wpgraphql می‌افتد (تا 404 /graphql نخورید)
// const GRAPHQL_URI = process.env.VUE_APP_GRAPHQL_ENDPOINT || "/wpgraphql";
// console.log("GraphQL endpoint:", GRAPHQL_URI);
// console.log(
//   "GraphQL endpoint:",
//   process.env.VUE_APP_GRAPHQL_ENDPOINT || "(fallback used)"
// );

// const apolloClient = new ApolloClient({
//   link: new HttpLink({ uri: "https://sinapardazesh.ir/graphql" }),
//   cache: new InMemoryCache(),
// });

// ایجاد اپ و رجیستر پلاگین‌ها/کامپوننت‌ها
const app = createApp(App);
app.use(createPinia());
// روش پیشنهادی: provide سراسری کلاینت آپولو
// app.provide(DefaultApolloClient, apolloClient);

// کامپوننت‌های گلوبال
app.component("DatePicker", Vue3PersianDatetimePicker);
app.component("font-awesome-icon", FontAwesomeIcon);
import ConfirmModal from '@/components/ConfirmModal.vue'
// Register confirm modal as global component for convenience
app.component('ConfirmModal', ConfirmModal);

// روتر
app.use(router);
app.use(Toast, toastOptions)
// مونت
app.mount("#app");

/*
  Global HTML5 validation message override (Persian)
  - Listens for the `invalid` event in capture mode and sets a customValidity
    message for required fields so the browser shows a Persian message instead
    of the default English text (e.g. "Please fill out this field.").
  - Clears customValidity on input/change so subsequent validation works normally.
*/
(function installPersianValidation() {
  const MESSAGE = 'لطفا اطلاعات این فیلد پر شود';

  // Catch invalid events in capture phase so we can set customValidity before
  // the browser displays the validation bubble/tooltip.
  document.addEventListener('invalid', function (e) {
    const t = e.target;
    try {
      if (!t) return;
      // only set for elements that participate in constraint validation
      if (typeof t.willValidate !== 'undefined' && t.willValidate) {
        // only replace message when value is missing and field is required
        if (t.required && t.validity && t.validity.valueMissing) {
          t.setCustomValidity(MESSAGE);
        }
      }
    } catch (err) {
      // defensive: some non-form controls might throw — avoid leaving block empty
      void err;
    }
  }, true);

  // Clear any custom validity once user types/selects so native validation runs
  // normally afterwards.
  const clear = (e) => {
    const t = e.target;
    if (!t) return;
  try { if (typeof t.setCustomValidity === 'function') t.setCustomValidity(''); } catch (err) { void err; }
  };
  document.addEventListener('input', clear, true);
  document.addEventListener('change', clear, true);
})();

// گارد احراز هویت
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
    // اگر نیاز به ورود دارد و توکن نیست → برو صفحه لاگین
    next("/");
  } else if (to.name === "Login" && token) {
    // اگر توکن هست و کاربر می‌خواهد برود صفحه لاگین → بفرستش به داشبورد
    next("/overview");
  } else {
    next();
  }
});
